import { Box, Col } from '@opendoor/bricks-next';
import { ThemedLite } from '@opendoor/bricks/theme/ODThemeLite';

import { EntryComponent } from '../../cms/entries/entries';
import { IComponentAccordionList } from '../../declarations/contentful';
import { Accordion } from '../shared/Accordion';

const renderAccordionList = (entry: IComponentAccordionList) => {
  const items = (entry.fields.items || []).map(({ fields }) => {
    return {
      title: fields?.title || '',
      body: fields?.body || '',
      // TODO: team to add unique panelId to fields and use this instead of title
      panelId: fields?.title || '',
    };
  });

  return (
    <Box className="embedded-entry-wrapper" $platform-web={{ gridColumn: '5 / -2' }}>
      <ThemedLite theme="legacy">
        <Col width="100%">
          {items.map((item) => (
            <Accordion key={item.panelId} {...item} />
          ))}
        </Col>
      </ThemedLite>
    </Box>
  );
};

const AccordionList: EntryComponent<IComponentAccordionList> = {
  render: renderAccordionList,
};

export default AccordionList;
